if (!customElements.get('philosophy-card-carousel')) {
  customElements.define(
    'philosophy-card-carousel',
    class PhilosophyCardCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-philosophy-track]');
        this.slides = Array.from(this.querySelectorAll('[data-philosophy-slide]'));
        this.previousButton = this.querySelector('[data-philosophy-previous]');
        this.nextButton = this.querySelector('[data-philosophy-next]');
        this.activeIndex = 0;
        this.pointerStartX = null;

        if (!this.track || this.slides.length === 0) return;

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.addEventListener('keydown', (event) => this.onKeydown(event));
        this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.track.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.track.addEventListener('pointercancel', () => {
          this.pointerStartX = null;
        });

        this.resizeObserver = new ResizeObserver(() => this.updateHeight());
        this.slides.forEach((slide) => this.resizeObserver.observe(slide));
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      move(direction) {
        this.activeIndex = (this.activeIndex + direction + this.slides.length) % this.slides.length;
        this.update();
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(1);
        }
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.pointerStartX = event.clientX;
      }

      onPointerUp(event) {
        if (this.pointerStartX === null) return;
        const distance = event.clientX - this.pointerStartX;
        this.pointerStartX = null;

        if (Math.abs(distance) <= 40) return;
        this.move(distance < 0 ? 1 : -1);
      }

      relativePosition(index) {
        let difference = index - this.activeIndex;
        const half = this.slides.length / 2;

        if (difference > half) difference -= this.slides.length;
        if (difference < -half) difference += this.slides.length;
        return difference;
      }

      update() {
        const positionClasses = [
          'is-active',
          'is-previous',
          'is-next',
          'is-far-previous',
          'is-far-next',
          'is-hidden',
        ];

        this.slides.forEach((slide, index) => {
          slide.classList.remove(...positionClasses);
          const position = this.relativePosition(index);

          if (position === 0) slide.classList.add('is-active');
          else if (position === -1) slide.classList.add('is-previous');
          else if (position === 1) slide.classList.add('is-next');
          else if (position < -1) slide.classList.add('is-far-previous');
          else if (position > 1) slide.classList.add('is-far-next');
          else slide.classList.add('is-hidden');

          slide.setAttribute('aria-hidden', position === 0 ? 'false' : 'true');
        });

        requestAnimationFrame(() => this.updateHeight());
      }

      updateHeight() {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          this.track.style.removeProperty('height');
          return;
        }

        const activeSlide = this.slides[this.activeIndex];
        if (activeSlide) this.track.style.height = `${activeSlide.offsetHeight}px`;
      }
    }
  );
}
